export default {"src":"/_next/static/media/invoice-icon.4c7a2d8d.svg","height":16,"width":16};